// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  background: #fff;
  padding: 72px 20px 56px;
  text-align: center;
  border-bottom: 1px solid var(--border);
}

.hero-inner {
  max-width: 700px;
  margin: 0 auto;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #eef2ff;
  color: var(--p1);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  border-radius: 20px;
  padding: 5px 14px;
  margin-bottom: 20px;
}

.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--p1);
  animation: blink 1.6s infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

.hero h1 {
  font-size: clamp(2rem, 4.5vw, 3.2rem);
  font-weight: 900;
  letter-spacing: -1.5px;
  line-height: 1.1;
  color: var(--text);
  margin-bottom: 14px;
}

.hero-desc {
  font-size: 1rem;
  color: var(--muted);
  margin-bottom: 32px;
  line-height: 1.65;
}

/* Search bar */
.hero-search {
  display: flex;
  align-items: center;
  background: #f3f4f6;
  border: 1.5px solid var(--border);
  border-radius: 14px;
  padding: 6px 6px 6px 16px;
  gap: 10px;
  max-width: 560px;
  margin: 0 auto 20px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.hero-search:focus-within {
  border-color: var(--p1);
  box-shadow: 0 0 0 3px rgba(79,70,229,0.12);
  background: #fff;
}

.hero-search svg { flex-shrink: 0; color: var(--muted2); }

.hero-search input {
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: 1rem;
  font-family: inherit;
  color: var(--text);
  outline: none;
}
.hero-search input::placeholder { color: var(--muted2); }

.hero-search-btn {
  background: var(--grad);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 12px 22px;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s, transform 0.15s;
  font-family: inherit;
}
.hero-search-btn:hover { opacity: 0.9; transform: translateY(-1px); }

.hero-quick {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 28px;
}

.hero-quick-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--muted2);
  margin-right: 4px;
}

.hero-quick-chip {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--radius-pill);
  padding: 6px 15px;
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-soft);
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s, background 0.2s;
}
.hero-quick-chip:hover {
  border-color: var(--p1);
  color: var(--p1);
  background: var(--brand-50);
}

.hero-trust {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.hero-trust-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  color: var(--muted);
  font-weight: 600;
}

.hero-trust-item svg { color: var(--p1); }

.hero-trust-sep {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--border);
}

@media (max-width: 500px) {
  .hero-trust-sep { display: none; }
  .hero-trust { gap: 10px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,mBAAmB,cAAc,EAAE,oBAAoB,EAAE;;AAEzD;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;AACA,kCAAkC,oBAAoB,EAAE;;AAExD;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,oBAAoB;AACtB;AACA,yBAAyB,YAAY,EAAE,2BAA2B,EAAE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,iCAAiC;EACjC,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uBAAuB,gBAAgB,EAAE;;AAEzC;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB,aAAa,EAAE;EACjC,cAAc,SAAS,EAAE;AAC3B","sourcesContent":[".hero {\n  background: #fff;\n  padding: 72px 20px 56px;\n  text-align: center;\n  border-bottom: 1px solid var(--border);\n}\n\n.hero-inner {\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: #eef2ff;\n  color: var(--p1);\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  border-radius: 20px;\n  padding: 5px 14px;\n  margin-bottom: 20px;\n}\n\n.badge-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--p1);\n  animation: blink 1.6s infinite;\n}\n\n@keyframes blink {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.3; }\n}\n\n.hero h1 {\n  font-size: clamp(2rem, 4.5vw, 3.2rem);\n  font-weight: 900;\n  letter-spacing: -1.5px;\n  line-height: 1.1;\n  color: var(--text);\n  margin-bottom: 14px;\n}\n\n.hero-desc {\n  font-size: 1rem;\n  color: var(--muted);\n  margin-bottom: 32px;\n  line-height: 1.65;\n}\n\n/* Search bar */\n.hero-search {\n  display: flex;\n  align-items: center;\n  background: #f3f4f6;\n  border: 1.5px solid var(--border);\n  border-radius: 14px;\n  padding: 6px 6px 6px 16px;\n  gap: 10px;\n  max-width: 560px;\n  margin: 0 auto 20px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n.hero-search:focus-within {\n  border-color: var(--p1);\n  box-shadow: 0 0 0 3px rgba(79,70,229,0.12);\n  background: #fff;\n}\n\n.hero-search svg { flex-shrink: 0; color: var(--muted2); }\n\n.hero-search input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  font-size: 1rem;\n  font-family: inherit;\n  color: var(--text);\n  outline: none;\n}\n.hero-search input::placeholder { color: var(--muted2); }\n\n.hero-search-btn {\n  background: var(--grad);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  padding: 12px 22px;\n  font-size: 0.92rem;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: opacity 0.2s, transform 0.15s;\n  font-family: inherit;\n}\n.hero-search-btn:hover { opacity: 0.9; transform: translateY(-1px); }\n\n.hero-quick {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 28px;\n}\n\n.hero-quick-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--muted2);\n  margin-right: 4px;\n}\n\n.hero-quick-chip {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-pill);\n  padding: 6px 15px;\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-soft);\n  cursor: pointer;\n  transition: border-color 0.2s, color 0.2s, background 0.2s;\n}\n.hero-quick-chip:hover {\n  border-color: var(--p1);\n  color: var(--p1);\n  background: var(--brand-50);\n}\n\n.hero-trust {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.hero-trust-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.82rem;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n.hero-trust-item svg { color: var(--p1); }\n\n.hero-trust-sep {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--border);\n}\n\n@media (max-width: 500px) {\n  .hero-trust-sep { display: none; }\n  .hero-trust { gap: 10px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
